export default {
  computed: {
    computedWinter50cm2009BCGovVisibility() {
      return this.$store.state.imagryLayers.winter50cm2009BCGov.visibility;
    }
  },
  methods: {
    mapLayerSatWinter50cm2009BCGovAdd() {
      this.map.addSource("sat-2009-50cm-tiles", {
        type: "raster",
        tiles: ["https://d2b5tdh71go5qb.cloudfront.net/{z}/{x}/{y}.png"],
        tileSize: 256
      });

      this.map.addLayer({
        id: "sat-2009-50cm-tiles",
        type: "raster",
        source: "sat-2009-50cm-tiles",
        layout: {
          visibility: "visible"
        }
      });

      this.map.moveLayer("sat-2009-50cm-tiles", "marker-layer-bottom");
    },
    mapLayerSatWinter50cm2009BCGovRemove() {
      this.map.removeLayer("sat-2009-50cm-tiles");
      this.map.removeSource("sat-2009-50cm-tiles");
    }
  },
  watch: {
    "$store.state.imagryLayers.winter50cm2009BCGov.visibility": function(
      newValue
    ) {
      if (newValue === true) {
        this.mapLayerSatWinter50cm2009BCGovAdd();
      } else {
        this.mapLayerSatWinter50cm2009BCGovRemove();
      }
    }
  }
};
